import type { CollectionChangedEventArgsInterface } from '@nts/std/interfaces';
import { CollectionChangedAction } from "@nts/std/types";

export class CollectionChangedEventArgs<T> implements CollectionChangedEventArgsInterface<T> {
    constructor(
        public action: CollectionChangedAction,
        public items: Array<T>,
        public itemsIndex?: Array<number>,
        public propertyNames?: Array<string>
    ) { }
}
